import { render, staticRenderFns } from "./TurnstileCaptcha.vue?vue&type=template&id=43dcc49c&"
import script from "./TurnstileCaptcha.vue?vue&type=script&lang=js&"
export * from "./TurnstileCaptcha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports